import React from "react";

import Tag from "antd/es/tag";
import { defineMessages, useIntl } from "react-intl";

import styles from "./DefaultCheckInVariantTag.module.scss";

const messages = defineMessages({
  name: {
    id: "settings.formLayouts.modal.variants.tags.defaultCheckInVariant",
    defaultMessage: "Default Check-in",
    description: "Default check-in tag title",
  },
});

const DefaultCheckInVariantTag = () => {
  const intl = useIntl();
  return <Tag className={styles.tag}>{intl.formatMessage(messages.name)}</Tag>;
};

export default DefaultCheckInVariantTag;
